'use es6';

import { getAll as getAllProblems } from '../../private/action-problem-solution/actions/view-dashboard-name/problem';
import { getProblem } from '../../private/action-problem-solution/common/get-problem';
import { isEnabled } from '../../private/action-problem-solution/common/is-enabled';
export const canViewDashboardName = params => isEnabled(params, getAllProblems);
export const getViewDashboardNameProblem = params => getProblem(params, getAllProblems);